!function(){
"use strict";

var baseTitle = "";
var titleEl = null;

function init(){
  titleEl = document.querySelector('h1[itemprop="name"]');
  if(!titleEl) return;

  // Base title
  var fullTitle = titleEl.textContent.trim();
  baseTitle = fullTitle.includes(" – ")
    ? fullTitle.split(" – ")[0].trim()
    : fullTitle;

  var select = document.getElementById("productSelect");

  if(select){
    select.addEventListener("change", updateTitle);
  }

  // Shopify URL change
  if(window.history && window.history.pushState){
    var push = history.pushState;
    history.pushState = function(){
      push.apply(history, arguments);
      updateTitle();
    };

    var replace = history.replaceState;
    history.replaceState = function(){
      replace.apply(history, arguments);
      updateTitle();
    };
  }

  // Mutation observer
  if(select && window.MutationObserver){
    new MutationObserver(updateTitle).observe(select, {
      attributes: true,
      attributeFilter: ["value"]
    });
  }

  updateTitle();
}

function cleanVariantText(text){
  if(!text) return "";

  // Remove price
  text = text.replace(/\s*-\s*[\$\₹\€\£].*$/g, "").trim();

  // 🔥 REMOVE Default Title COMPLETELY
  text = text.replace(/Default Title/gi, "");

  // 🔥 Remove leftover " - " or "-"
  text = text.replace(/\s+-\s+/g, " ").trim();

  // 🔥 Replace ONLY separator " / " → " | "
  text = text.replace(/\s\/\s/g, " | ");

  // Final trim
  return text.trim();
}

function updateTitle(){
  if(!titleEl || !baseTitle) return;

  var select = document.getElementById("productSelect");
  if(!select) return;

  var option = select.options[select.selectedIndex];
  if(!option) return;

  var rawText = option.text.trim();

  var variant = cleanVariantText(rawText);

  // 🔥 FIXED CONDITION
  if(variant && variant.replace(/[-–|\s]/g, "") !== ""){
    var finalTitle = baseTitle + " – " + variant;

    titleEl.textContent = finalTitle;
    document.title = finalTitle;
  } else {
    titleEl.textContent = baseTitle;
    document.title = baseTitle;
  }
}

// DOM ready
if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}

// Shopify callback hook
if(typeof jQuery !== "undefined"){
  jQuery(document).ready(function(){
    setTimeout(function(){
      var original = window.selectCallback;

      window.selectCallback = function(variant, selector){
        if(typeof original === "function"){
          original(variant, selector);
        }
        updateTitle();
      };
    }, 500);
  });
}

}();